
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Buchung erstellen",
  detailsTitle: "Buchungsdetails",
  createdOn: "erstellt am",
  statusBooked: "Gebucht",
  processing: "Wird verarbeitet...",
  reject: "Ablehnen",
  cancelled: "Buchung storniert",
  guests: "Gäste",
  nights: "Nächte",
 
  responsibleTitle: "Buchungsverantwortlicher",
  name: "Name",
  email: "E-Mail",
  emailNotProvided: "Keine E-Mail angegeben",
  phone: "Telefon",
  phoneNotProvided: "Keine Telefonnummer angegeben",
  replyWhatsapp: "Auf WhatsApp antworten",
  notes: "Notiz",
  notesEmpty: "Keine Notiz",
  notesPlaceholder: "Interne Notizen zur Buchung (z. B. späte Anreise, Babybett, Allergien…)",
  notesEdit: "Notiz bearbeiten",
  notesSave: "Speichern",
  notesCancel: "Abbrechen",
  notesSaved: "Notiz aktualisiert",
  notesSaveError: "Die Notiz konnte nicht gespeichert werden",
 
  amountTitle: "Buchungsbetrag",
 
  // Menu buttons & states
  validatingLink: "Link wird geprüft...",
  sendPaymentLink: "Zahlungslink senden",
  copyPaymentLink: "Zahlungslink kopieren",
  sendingPaymentLink: "Zahlungslink wird gesendet…",
  whatsappSent: "Zahlungslink per WhatsApp gesendet.",
  whatsappSentFallback: "Vorlage konnte nicht gesendet werden. WhatsApp wurde manuell geöffnet.",
  freeReservationInfo: "Kostenlose Buchung - Keine Zahlung erforderlich",
  stripeNotConfigured: "Stripe nicht konfiguriert",
  changePaymentStatus: "Zahlungsstatus ändern",
 
  // Amount status
  amountStatus: "Status des Betrags",
  paymentPending: "Zahlung ausstehend",
  paid: "Bezahlt",
  rejected: "Abgelehnt",
  refunded: "Erstattet",
  partial: "Teilzahlung",
 
  // Totals
  subtotal: "Zwischensumme:",
  totalDiscounts: "Rabatte gesamt:",
  totalTaxes: "Steuern gesamt:",
  total: "Gesamt:",
 
  // Payment status modal
  changePaymentStatusHeader: "Zahlungsstatus ändern",
  paymentStatusLabel: "Zahlungsstatus",
  select: "Auswählen",
  pending: "Ausstehend",
  paidShort: "Bezahlt",
  close: "Schließen",
  saveChanges: "Änderungen speichern",
 
  // Toastr / Messages
  paymentUrlSuccess: "Zahlungs-URL erfolgreich erzeugt",
  paymentUrlError: "Fehler beim Erzeugen der Zahlungs-URL",
 
  linkGenerated: "Zahlungslink erfolgreich erzeugt",
  linkRegenerated: "Zahlungslink wegen Preisänderungen aktualisiert",
  linkPriceZero: "Für kostenlose Buchungen ($0) kann kein Zahlungslink erzeugt werden",
  linkNoStripe: "Der Benutzer hat Stripe nicht für den Zahlungsempfang konfiguriert",
  linkNoProvider: "Kein Zahlungsanbieter konfiguriert (Stripe oder Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Der Zahlungslink kann nicht erzeugt werden. Es fehlen erforderliche Daten.",
  linkValidateError: "Fehler beim Prüfen des Zahlungslinks",
  linkValid: "Der Zahlungslink ist gültig",
 
  copySuccess: "Der Link wurde erfolgreich kopiert",
  copied: "Kopiert!",
  copyError: "Beim Kopieren des Links ist ein Fehler aufgetreten",
  error: "Fehler",
  statusUpdatedSuccess: "Status erfolgreich aktualisiert",
  statusUpdatedError: "Fehler beim Aktualisieren des Zahlungsstatus",  // ✅ NUEVA
 
  // WhatsApp
  whatsappPayMessage: "Hallo {name}! Hier ist Ihr Link zur Bezahlung Ihrer Buchung: {url}",
 
  checkinsOf: "Check-ins zu dieser Buchung ({done} von {total})",
  completed: "Abgeschlossen",
  pendings: "Ausstehend",
  date: "Datum",
  noCheckinsYet: "Die Gäste dieser Buchung haben den Check-in noch nicht abgeschlossen",
 
  alojamiento: "Unterkunft",
};
 
